module.exports = __webpack_public_path__ + "img/myproject.4bb2b056.png";